import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { orgQueryKeys } from "@/global-settings/data/orgQueryKeys";

export function useAPIKeysData(appId?: string) {
  const { org } = useEnvironment();

  return useQuery({
    queryKey: orgQueryKeys.apiKeys(org.id, appId),
    queryFn: () =>
      api
        .get<"/orgs/:orgId/api-keys">(`/orgs/${org.id}/api-keys`, {
          params: { appId },
        })
        .then((res) => res.data),
  });
}
